export default __webpack_public_path__ + "static/media/Icon-download.81951e61.svg";